<script lang="ts" setup>
const auth = useAuth()

// Auth resolves client-side: render the public body during SSR + first client render
// to avoid a hydration mismatch, then swap once logged in and a project is resolved.
const showPostLogin = ref(false)
onMounted(() => {
  const sync = () => {
    showPostLogin.value = auth.isLoggedIn && !!auth.project
  }
  sync()
  watch([() => auth.isLoggedIn, () => auth.project], sync)
})
</script>

<template>
  <NuxtLayout
    name="homepage"
    title="Forgd"
    :seo="{
      title: 'Forgd | Launch & scale your token with conviction',
      description: 'Tap on Forgd\'s self-service tools, expert advisors, and curated data from over 1500+ blockchain projects to get the insights that matter. Free of charge.',
    }"
  >
    <template #subheader>
      <ClientOnly>
        <HomeRankingsTicker />
        <template #fallback>
          <PrMmRankingsTicker :items="[]" loading />
        </template>
      </ClientOnly>
    </template>

    <template #default>
      <HomePostLogin v-if="showPostLogin" />
      <HomePreLogin v-else />
    </template>

    <template #footer>
      <CoreSupportCta
        class="md:hidden"
        cta="Contact us for a 1:1 consultation regarding all things related to your project's roadmap"
      />

      <CoreAppFooterBlock class="hidden md:block" footer-class="max-w-360" />
    </template>
  </NuxtLayout>
</template>
